import { initOutputDateRange } from "src/features/PageConfigProvider/constants/initOutputDateRange";
import { FilterFields } from "../types/FilterFields";

export const initFields: FilterFields = {
  creationTime: initOutputDateRange,
  lastModifiedTime: initOutputDateRange,
  chainName: "",
  status: [],
  batchId: "",
  operationType: [],
};
